export var isNull = function isNull(x) {
  return x === null;
};